'use client';

import { useHashParameters } from '@packages/modules/src/hooks/useHashParameters/useHashParameters';
import { PrudsysProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/PrudsysProductsRecoSlider/PrudsysProductsRecoSlider.client';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useIntl } from 'react-intl';
import type { RawProductData } from '../../../types';

export type PrudsysProductsRecommendationsProps = {
  defaultCategory: RawProductData['defaultCategory'];
  orderNumber: RawProductData['orderNumber'];
  brand: RawProductData['brand'];
  title: string | undefined;
};

/**
 * The `PrudsysProductsRecommendations` component is used as a wrapper for the `PrudsysProductsRecoSlider` component.
 * It displays the recommendations for the prudsysProducts Query.
 * */
export const PrudsysProductsRecommendations = ({
  brand,
  defaultCategory,
  orderNumber,
  title,
}: PrudsysProductsRecommendationsProps) => {
  const { category = '' } = useHashParameters();
  const { formatMessage } = useIntl();
  const {
    product: { hasTransparentSection },
  } = useConfig();

  return (
    <PrudsysProductsRecoSlider
      brand={brand?.name ?? ''}
      categoryIds={[defaultCategory ?? category]}
      productId={orderNumber}
      pageTemplate="detailview"
      fetchOnThreshold
      elementIndex={0}
      title={
        title ||
        formatMessage({
          defaultMessage: 'Andere Kunden interessierte auch',
          id: 'rde.prudsys.headline-fallback',
        })
      }
      key={`${orderNumber}0`}
      {...(hasTransparentSection && {
        backgroundColor: 'transparent',
      })}
    />
  );
};
